// Gymnastics events (used throughout the app for dropdowns, labels, video tagging)
export const GYMNASTICS_EVENTS = [
  { value: 'vault', label: 'Vault' },
  { value: 'uneven_bars', label: 'Uneven Bars' },
  { value: 'balance_beam', label: 'Balance Beam' },
  { value: 'floor_exercise', label: 'Floor Exercise' },
  { value: 'pommel_horse', label: 'Pommel Horse' },
  { value: 'still_rings', label: 'Still Rings' },
  { value: 'parallel_bars', label: 'Parallel Bars' },
  { value: 'horizontal_bar', label: 'High Bar' },
  { value: 'trampoline', label: 'Trampoline' },
  { value: 'tumbling', label: 'Tumbling' },
  { value: 'acro', label: 'Acro' },
  { value: 'landing', label: 'Landing Assessment' },
];

// User roles
export const ROLES = {
  SUPERADMIN: 'superadmin',
  STAFF: 'staff',
  ADMIN: 'admin',
  COACH: 'coach',
  PARENT: 'parent',
  ATHLETE: 'athlete',
};

export const RMT_ROLES = [ROLES.SUPERADMIN, ROLES.STAFF];

export const ROLE_LABELS = {
  superadmin: 'Super Admin',
  staff: 'RMT Staff',
  admin: 'Gym Admin',
  coach: 'Coach',
  parent: 'Parent',
  athlete: 'Athlete',
};

// Video analysis statuses
export const ANALYSIS_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const ANALYSIS_STATUS_LABELS = {
  pending: 'Queued',
  processing: 'Analyzing...',
  completed: 'Complete',
  failed: 'Failed',
};

// Landing types for classification
export const LANDING_TYPES = [
  { value: 'good', label: 'Good Landing' },
  { value: 'over_rotated', label: 'Over Rotated' },
  { value: 'under_rotated', label: 'Under Rotated' },
  { value: 'step_out', label: 'Step Out' },
  { value: 'fall', label: 'Fall' },
  { value: 'short', label: 'Short' },
];

export const RISK_CATEGORIES = {
  low: { label: 'Low Risk', color: 'text-green-600', bg: 'bg-green-50' },
  moderate: { label: 'Moderate Risk', color: 'text-yellow-600', bg: 'bg-yellow-50' },
  high: { label: 'High Risk', color: 'text-orange-600', bg: 'bg-orange-50' },
  critical: { label: 'Critical Risk', color: 'text-red-600', bg: 'bg-red-50' },
};

// Invoice statuses
export const INVOICE_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  FAILED: 'failed',
  OVERDUE: 'overdue',
};

// Days of week (for class schedules)
export const DAYS_OF_WEEK = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

// Navigation items by role
export const NAV_ITEMS = {
  [ROLES.ADMIN]: ['dashboard', 'video', 'athletes', 'classes', 'calendar', 'attendance', 'billing', 'communication', 'waivers', 'staff', 'admin'],
  [ROLES.COACH]: ['dashboard', 'video', 'athletes', 'classes', 'calendar', 'attendance', 'communication', 'skills'],
  [ROLES.ATHLETE]: ['dashboard', 'video', 'profile', 'calendar', 'skills'],
  [ROLES.PARENT]: ['dashboard', 'athletes', 'calendar', 'billing', 'communication', 'waivers'],
  [ROLES.SUPERADMIN]: ['dashboard', 'video', 'athletes', 'classes', 'calendar', 'billing', 'admin', 'superadmin'],
};
